/**
 * Bunny Shield API
 * Bunny.net API for Bunny Shield (WAF, DDoS, Rate Limiting, Bot Detection, Access Lists & API Guardian).

 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 0 = Auto 1 = TwoMinutes 2 = TenMinutes 3 = Hourly 4 = Daily 5 = Weekly 6 = Monthly
 */
export type MetricsOverviewResolution = 0 | 1 | 2 | 3 | 4 | 5 | 6;

export const MetricsOverviewResolution = {
  Auto: 0 as MetricsOverviewResolution,
  TwoMinutes: 1 as MetricsOverviewResolution,
  TenMinutes: 2 as MetricsOverviewResolution,
  Hourly: 3 as MetricsOverviewResolution,
  Daily: 4 as MetricsOverviewResolution,
  Weekly: 5 as MetricsOverviewResolution,
  Monthly: 6 as MetricsOverviewResolution,
};
